@let currentState = state();

@let uploadState = current();
@let _remaining = uploadState?.remaining;
@let _speed = uploadState?.speed;

@let localState = localStatus();
@let _progress = localState.progress;
@let _uploaded = localState.uploaded ?? 0;
@let _size = localState.size ?? 0;

<div class="file">
  <div class="file__header">
    @let filename = uploadState?.file?.name;
    <p class="file__name">
      <span>{{ filename }}</span>
    </p>

    <div class="file__actions">
      @if (cancellable()) {
        <evc-button
          icon="close"
          size="small"
          frame="none"
          (click)="cancelFile(current.uploadId)"></evc-button>
      }
    </div>
  </div>

  @let mode =
    currentState === UploadFileStates.PENDING || currentState === UploadFileStates.UNKNOWN
      ? progressBarModes.INDETERMINATE
      : progressBarModes.DETERMINATE;

  @let loadingState =
    currentState === UploadFileStates.COMPLETE
      ? progressBarStates.SUCCESS
      : currentState === UploadFileStates.CANCEL
        ? progressBarStates.WARNING
        : currentState === UploadFileStates.ERROR
          ? progressBarStates.ERROR
          : progressBarStates.INFO;

  <evc-progress-bar
    [progressValue]="loadingState === progressBarStates.INFO ? _progress : 100"
    [mode]="mode"
    [state]="loadingState" />

  <p class="file__hint">
    @if (state() === UploadFileStates.PROGRESS && _speed) {
      @if (_remaining >= 0) {
        <span>{{ _remaining | remaining }}</span>
      }
      @if (_remaining >= 0 && _speed >= 0) {
        &nbsp;-&nbsp;
      }
      @if (_speed >= 0) {
        <span>{{ _speed | filesize }}{{ 'unit.perSecond' | translate }}</span>
      }
    } @else {
      @let hint =
        currentState === UploadFileStates.PENDING
          ? ('upload.hint.pending' | translate)
          : currentState === UploadFileStates.PROGRESS
            ? ('upload.hint.uploading' | translate)
            : currentState === UploadFileStates.COMPLETE
              ? ('upload.hint.complete' | translate)
              : currentState === UploadFileStates.CANCEL
                ? ('upload.hint.cancelled' | translate)
                : currentState === UploadFileStates.ERROR
                  ? (current.error || 'upload.hint.failed' | translate)
                  : false;

      @if (hint) {
        <span>{{ hint }}</span>
      }
    }

    @if (_uploaded > 0 && _size > 0) {
      <span class="file__progress"> {{ _uploaded | filesize }}/{{ _size | filesize }} </span>
    }
  </p>
</div>
